import styled from 'styled-components';
import { Trans } from '@lingui/react';
import TransHTML from '~/components/transHTML';
import { t } from '@lingui/macro';

import { SectionContainer, ContentWrapper } from '~/styles/common';

const TheStory = () => {
    return (
        <StorySectionContainer>
            <ContentWrapper>
                <Heading>
                    <Trans id="global.about.theStory.heading" />
                </Heading>
                <Wrapper>
                    <Point>
                        <TransHTML id={t`global.about.theStory.point1`} />
                    </Point>
                    <Point>
                        <TransHTML id={t`global.about.theStory.point2`} />
                    </Point>

                    <Point>
                        <TransHTML id={t`global.about.theStory.point3`} />
                    </Point>

                    <Point>
                        <TransHTML
                            id={t`global.about.theStory.point4_firstPart`}
                        />{' '}
                        <ExternalLink href="https://startupwiseguys.com/" target="_blank">
                            Startup Wise Gyus
                        </ExternalLink>{' '}

                        <TransHTML
                            id={t`global.about.theStory.point4_secondPart`}
                        />{' '}
                        <ExternalLink href="https://www.seedrs.com/businesses/trisbee" target="_blank">
                            Seedrs
                        </ExternalLink>
                        .
                    </Point>

                    <Point>
                        <TransHTML id={t`global.about.theStory.point5`} />
                    </Point>
                </Wrapper>
            </ContentWrapper>
        </StorySectionContainer>
    );
};

const Heading = styled.div`
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 26px;
    color: #0cc8a8;
    margin-bottom: 24px;
`;

const StorySectionContainer = styled(SectionContainer)``;
const Wrapper = styled.div`
    width: 100%;
`;

const ExternalLink = styled.a`
    font-weight: bold;
    font-size: 20px;
    line-height: 31px;
    text-decoration-line: underline;
    color: #0cc8a8;
`;

const Point = styled.div`
    margin-top: 24px;
    font-size: 20px;
    line-height: 31px;
    color: #525252;
`;

export default TheStory;
